module.exports = __webpack_public_path__ + "static/moonlitNightClassicalSnippet3Arranged-23f3fa3d7ac27fc81c2c9002510b517b.mp3";